class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('.price-range-slider__input--min');
    this.maxInput = this.querySelector('.price-range-slider__input--max');
    this.minField = this.querySelector('[data-price-slider-field="min"]');
    this.maxField = this.querySelector('[data-price-slider-field="max"]');
    this.minLabel = this.querySelector('.price-range-slider__value--min');
    this.maxLabel = this.querySelector('.price-range-slider__value--max');
    this.trackFill = this.querySelector('.price-range-slider__track-fill');

    this.minInput.addEventListener('input', this.onInput.bind(this));
    this.maxInput.addEventListener('input', this.onInput.bind(this));

    this.minInput.addEventListener('change', this.onChange.bind(this));
    this.maxInput.addEventListener('change', this.onChange.bind(this));

    this.update();
  }

  onInput() {
    // Prevent handles from crossing
    if (parseInt(this.minInput.value) > parseInt(this.maxInput.value) - 1) {
      this.minInput.value = parseInt(this.maxInput.value) - 1;
    }
    if (parseInt(this.maxInput.value) < parseInt(this.minInput.value) + 1) {
      this.maxInput.value = parseInt(this.minInput.value) + 1;
    }
    this.update();
  }

  onChange() {
    this.minField.value = this.minInput.value;
    this.maxField.value = this.maxInput.value;

    // Trigger the same event Dawn's facets.js listens for
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  update() {
    const min = parseInt(this.minInput.min);
    const max = parseInt(this.minInput.max);
    const minVal = parseInt(this.minInput.value);
    const maxVal = parseInt(this.maxInput.value);

    const minPercent = ((minVal - min) / (max - min)) * 100;
    const maxPercent = ((maxVal - min) / (max - min)) * 100;

    this.trackFill.style.left = `${minPercent}%`;
    this.trackFill.style.right = `${100 - maxPercent}%`;

    this.minLabel.textContent = this.formatMoney(minVal);
    this.maxLabel.textContent = this.formatMoney(maxVal);
  }

  formatMoney(cents) {
    // Adjust divisor/currency formatting to match your store's money format
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
  }
}

customElements.define('price-range-slider', PriceRangeSlider);